import React from 'react';
import PropTypes from 'prop-types';
import {
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import useTable from '../../../../components/useTable';
import ResetSetting from '../../../ResetSettingButton';

const NON_EDITABLE_FIELDS = [
  'accessToken',
  'refreshToken',
  'accessTokenExpireTime',
  'refreshTokenExpireTime',
];

const headers = [
  { id: 'nonEditableSetting', label: 'Non Editable Setting' },
  { id: 'value', label: 'Value' },
  { id: 'action', label: 'Action' },
];

export default function AccuroNonEditableSettingTable(props) {
  const {
    entity,
    accuroSettings,
    refreshParent,
    setSuccessMessage,
    setErrorMessage,
  } = props;
  const nonEditableSettings = Object.entries(accuroSettings).filter(
    ([key, setting]) => NON_EDITABLE_FIELDS.includes(key) && setting && setting.value !== undefined,
  );

  const {
    TblContainer,
    TblHead,
  } = useTable(nonEditableSettings, headers, { fn: (items) => items });

  return (
    <TblContainer>
      <TblHead />
      <TableBody>
        {nonEditableSettings.map(([key, setting]) => {
          const { isDefault, ...settingValues } = setting;
          return (
            <TableRow key={key}>
              <TableCell>{key}</TableCell>
              <TableCell>
                {settingValues.value}
              </TableCell>
              <TableCell>
                <ResetSetting
                  entity={entity}
                  type="site"
                  setting={settingValues}
                  refreshParent={refreshParent}
                  setSuccessMessage={setSuccessMessage}
                  setErrorMessage={setErrorMessage}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </TblContainer>
  );
}

// First, define a reusable setting shape
const settingShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

AccuroNonEditableSettingTable.propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    settings: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      category: PropTypes.string,
      value: PropTypes.string,
    })),
  }).isRequired,
  accuroSettings: PropTypes.shape({
    enabled: settingShape.isRequired,
    uuid: settingShape.isRequired,
    accessToken: settingShape.isRequired,
    refreshToken: settingShape.isRequired,
    accessTokenExpireTime: settingShape.isRequired,
    refreshTokenExpireTime: settingShape.isRequired,
    sentSMSStatus: settingShape.isRequired,
    notSentSMSStatus: settingShape.isRequired,
    intakeCompletedStatus: settingShape.isRequired,
    preBookedAutomationEnabled: settingShape.isRequired,
    sameDayAutomationEnabled: settingShape.isRequired,
    daysBeforeAppointment: settingShape.isRequired,
    folderId: settingShape.isRequired,
    subFolderId: settingShape.isRequired,
    appointmentType: settingShape.isRequired,
    sendDays: settingShape.isRequired,
    appointmentReasonIds: settingShape.isRequired,
    filterByProviderIds: settingShape.isRequired,
    providerIds: settingShape.isRequired,
    intakePlans: settingShape.isRequired,
  }).isRequired,
  refreshParent: PropTypes.func.isRequired,
  setSuccessMessage: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
};
